export const attendanceFormlayoutResources = {
  header: "Attendance Form",
  privacyLink: "Privacy Notice",
  privacyLinkAddress: "https://kpmg.com/uk/en/home/misc/privacy.html",
  footerCopyright: "© ",
  footer:
    " KPMG LLP a UK limited liability partnership and a member firm of the KPMG global organisation of independent member firms affiliated with KPMG International Limited, a private English company limited by guarantee. All rights reserved.",
};
